<div class="base">
    <div class="contenedor">
        <div class="contenido">
            <div class="msgbox">
                <div class="msgbox-header">
                    <h4>{{mbTitulo}}</h4>
                </div>
                <div class="msgbox-body">
                    <br>
                    <p>{{mbTexto1}}</p>
                    <p>{{mbTexto2}}</p>
                    <br>
                </div>
                <div class="msgbox-footer" [ngStyle]="lineaBotonesStyle">
                    <div *ngIf="vfAceptar" (click)="emitirRespuesta('Aceptar')" class="msgbox-button"
                        [ngStyle]="botonStyle">Aceptar {{tiempoAceptar}}</div>
                    <div *ngIf="vfCancelar" (click)="emitirRespuesta('Cancelar')" class="msgbox-button"
                        [ngStyle]="botonStyle">Cancelar</div>
                    <div *ngIf="vfSi" (click)="emitirRespuesta('Sí')" class="msgbox-button" 
                        [ngStyle]="botonStyle">Sí</div>
                    <div *ngIf="vfNo" (click)="emitirRespuesta('No')" class="msgbox-button" 
                        [ngStyle]="botonStyle">No</div>
                    <div *ngIf="vfSalir" (click)="emitirRespuesta('Salir')" class="msgbox-button"
                        [ngStyle]="botonStyle">Salir</div>
                </div>
            </div>
        </div>
    </div>
</div>